import React from "react";
import { Field } from "@progress/kendo-react-form";
import { Checkbox as ProgressCheckbox } from "@progress/kendo-react-inputs";
import { connect } from "react-redux";

class CLCheckBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false,
    };
  }

  componentDidMount() {
    if (this.props.isEditMode) {
      this.setState({
        isChecked: this.props.task.checklistTask.value === "true" ? true : false,
      });
    }
  }

  checkBoxChange = (event) => {
    let obj = {
      templateName: this.props.templateName,
      sequence: this.props.sequence,
      value: event.target.value + "",
    };
    this.props.onChange(obj);
    this.setState({
      isChecked: event.target.value,
    });
  };

  render() {
    let child = null;
    if (this.props.isEditMode) {
      child = (
        <Field
          style={{ padding: 5 }}
          name={this.props.task.id}
          component={ProgressCheckbox}
          onChange={this.checkBoxChange}
          defaultValue={
            this.props.task.checklistTask.value === "true" ? true : false
          }
          value={this.state.isChecked}
          disabled={this.props.isDeleteMode || !this.props.canUpdate}
        />
      );
    } else {
      child = (
        <Field
          style={{ padding: 5 }}
          name={this.props.task.id}
          component={ProgressCheckbox}
          onChange={this.checkBoxChange}
          defaultValue={this.state.isChecked}
          value={this.state.isChecked}
          disabled={this.props.isDeleteMode || !this.props.canUpdate}
        />
      );
    }

    let panel = (
      <>
        <tr className={"k-master-row"}>
          <td
            style={{
              verticalAlign: "top",
              paddingLeft: 5,
            }}
          >
            {this.props.task.taskTemplate.name}
          </td>
          <td
            style={{
              verticalAlign: "top",
              paddingLeft: 5,
            }}
          >
            {this.props.task.taskTemplate.description}
          </td>
          <td
            style={{
              verticalAlign: "top",
              paddingLeft: 5,
            }}
          >
            <div className={"checklistBoxes"}>{child}</div>
          </td>
        </tr>
      </>
    );
    return <React.Fragment>{panel}</React.Fragment>;
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CLCheckBox);
